import React from "react";
import { Code2, ShieldCheck, Rocket, ArrowRight, Sparkles } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";

function Herosection() {
  const { theme } = useTheme();
  return (
    <section className="relative min-h-screen overflow-hidden bg-white dark:bg-[#050505] pt-32 px-6 lg:px-16 transition-all duration-300">
      {/* GLOW EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/20 blur-[140px] rounded-full"></div>

      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/20 blur-[140px] rounded-full"></div>

      {/* GRID */}
      <div
        className="absolute inset-0 
      bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] 
      dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] 
      bg-[size:70px_70px]"
      ></div>

      {/* MAIN CONTAINER */}
      <div className="relative z-10 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        {/* LEFT CONTENT */}
        <div>
          {/* TOP BADGE */}
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-primary/20 bg-primary/10 backdrop-blur-xl mb-2">
            <Sparkles className="w-4 h-4 text-primary" />

            <span className="text-sm text-primary font-medium tracking-wide">
              Next Generation Web Solutions
            </span>
          </div>

          {/* HEADING */}
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 dark:text-white">
            Build Powerful
            <span className="block bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Digital Experiences
            </span>
          </h1>

          {/* SUB HEADING */}
          <h2 className="font-dancing mysubheading text-gray-800 dark:text-gray-200 ">
            Web Solutions for Lead Generation with marketing
          </h2>

          {/* PARAGRAPH */}
          <p className="myparagraph text-gray-900 dark:text-gray-300 leading-normal">
            We build modern websites, scalable dashboards, SaaS platforms, and
            premium digital experiences with futuristic UI systems, optimized
            performance, and powerful user experiences for startups, agencies,
            and enterprises.
          </p>

          {/* FEATURE TAGS */}
          <div className="mt-6 flex flex-wrap gap-4">
            <div className="flex items-center gap-3 px-5 py-2 rounded-lg border border-primary/30 bg-white/70 dark:bg-white/5 backdrop-blur-xl shadow-sm">
              <Code2 className="w-5 h-5 text-primary" />

              <span className="text-xs font-medium text-gray-700 dark:text-gray-200">
                Web Development
              </span>
            </div>

            <div className="flex items-center gap-3 px-5 py-2 rounded-lg border border-primary/30 bg-white/70 dark:bg-white/5 backdrop-blur-xl shadow-sm">
              <ShieldCheck className="w-5 h-5 text-primary" />

              <span className="text-xs font-medium text-gray-700 dark:text-gray-200">
                Digital Marketing
              </span>
            </div>

            <div className="flex items-center gap-3 px-5 py-2 rounded-lg border border-primary/30 bg-white/70 dark:bg-white/5 backdrop-blur-xl shadow-sm">
              <Rocket className="w-5 h-5 text-primary" />

              <span className="text-xs font-medium text-gray-700 dark:text-gray-200">
                Performance Optimized
              </span>
            </div>
          </div>

          {/* BUTTONS */}
          <div className="mt-10 flex flex-wrap gap-5">
            {/* PRIMARY BUTTON */}
            <Link
              to="https://webxsecure.in/contact"
              className="group flex items-center gap-2 px-5 py-2 rounded-lg bg-primary text-white font-semibold shadow-[0_0_40px_rgba(254,120,83,0.35)] hover:scale-105 transition-all duration-300"
            >
              Get Started
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition" />
            </Link>

            {/* SECONDARY BUTTON */}
            <Link
              to="https://webxsecure.in/case-study"
              target="_blank"
              className=" px-5 py-2 rounded-lg border border-primary/30 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl text-gray-800 dark:text-white font-medium hover:scale-105 transition-all duration-300"
            >
              View Projects
            </Link>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="relative flex justify-center items-center">
          {/* GLOW */}
          <div className="absolute w-[450px] h-[450px] bg-primary/20 blur-[120px] rounded-full"></div>

          <div className="absolute w-[350px] h-[350px] bg-orange-300/20 blur-[120px] rounded-full"></div>

          {/* IMAGE CARD */}
          <div className="relative group">
            <div className="relative rounded-[30px] border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-2xl p-3 shadow-[0_0_60px_rgba(254,120,83,0.15)]">
              {/* IMAGE */}
              <img
                src={
                  theme === "light"
                    ? "webxsecure-result-light.png"
                    : "webxsecure-results.png"
                }
                alt="Dashboard Preview"
                className="w-full max-w-[720px] rounded-[24px] object-cover"
              />

              {/* TOP DOTS */}
              <div className="absolute top-6 right-6 flex gap-2">
                <span className="w-3 h-3 rounded-full bg-primary shadow-[0_0_12px_#fe7853]"></span>

                <span className="w-3 h-3 rounded-fullbg-primary shadow-[0_0_12px_#fb923c]"></span>

                <span className="w-3 h-3 rounded-full bg-yellow-400 shadow-[0_0_12px_#facc15]"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Herosection;
